<template>
  <div class="hello">
    
    <div class="Joinbanner">
  
      <div class="MethodsBanner"><img src="../assets/Joinbanner.png" class="MethodsPic"></div>
  
    </div>
  
    <div class="Job" >
  
      <div class="center-title">
  
        <h4 class="titleC">招聘职位</h4>
  
        <p class="titleEnglish">Recruiting position</p>
  
        <div class="blueLine"></div>
  
        <div class="greyLine"></div>
  
      </div>
  
      <div class="example">
  
        <el-row :gutter="20" type="flex" class="row-bg" justify="center" style="margin-right: 0;margin-left: 0;margin-top:45px;padding-bottom: 57px ">
  
          <el-col :span="3" v-for="(bottleneck,index) in bottleNeck" style="width: 146px;height: 171px">
  
            <div :body-style="{ padding: '0px' }" style="height: auto">
  
              <img :src="bottleneck.pic" class="image">
  
            </div>
  
          </el-col>
  
        </el-row>
  
      </div>
  
      <div class="search">
  
        <div class="searchContent">
  
        <input autocomplete="off" placeholder="请输入您要搜索的岗位关键词" type="text" rows="2" validateevent="true" class="job-input"  v-model="searchContent">
  
        <img src="../assets/searchButton.png" class="searchImg" @click="search">
  
        <img src="../assets/ho-t.png" class="searchHot">
  
        <p class="hotContent"><span style="font-size: 14px;display: inline-block;margin-right: 10px;">热招岗位：</span><span class="JobsName" @click="JavaEngineer">Java高级工程师</span>&nbsp&nbsp<span class="JobsName" @click="JavaEngineer">商务经理</span>&nbsp&nbsp<span class="JobsName" @click="JavaEngineer">运维员</span></p>
  
      </div>

      </div>
  
      
  
      <div class="searchContent2">
  
        <h4 class="Jobtitle">急招职位</h4>
  
        <ul class="Joblist">
  
          <li v-for="(job,index) in Jobs" :class="{color:job.color}">
  
            <p class="JobName">{{job.name}}</p>
  
            <img :src="job.button" class="LearnMoreButton" @mouseover="mouseOn(index)" @mouseout="mouseOut(index)" @click="onclick(index)">
  
          </li>
  
        </ul>
  
      </div>
  
    </div>
  
  </div>
</template>

<script>
  import pic1 from "../assets/a1.png"
  
  import pic2 from "../assets/a2.png"
  
  import pic3 from "../assets/a3.png"
  
  import pic4 from "../assets/a4.png"
  
  import pic5 from "../assets/a5.png"
  
  import pic6 from "../assets/a6.png"
  
  import button1 from "../assets/More.png"
  
  import button2 from "../assets/Moremouse.png"
  
  import button3 from "../assets/Moreclick.png"

  export default {
  
    name: 'hello',

    data() {
  
      return {
  
        activePic: [{
  
          show: true
  
        }, {
  
          show: true
  
        }, {
  
          show: true
  
        }, {
  
          show: true
  
        }, {
  
          show: true
  
        }, {
  
          show: true
  
        }],
  
  
  
        bottleNeck: [{
  
          id: 0,
  
          pic: pic1
  
        }, {
  
          id: 1,
  
          pic: pic2
  
        }, {
  
          id: 2,
  
          pic: pic3
  
        }, {
  
          id: 3,
  
          pic: pic4
  
        }, {
  
          id: 4,
  
          pic: pic5
  
        }, {
  
          id: 5,
  
          pic: pic6
  
        }],
  
        Jobs: [{
  
          id: 0,
  
          name: 'Java高级开发工程师',
  
          button: button1,
  
          color: false,
  
        }, {
  
          id: 1,
  
          name: 'Java中级开发工程师',
  
          button: button1,
  
          color: true,
  
        }, {
  
          id: 2,
  
          name: '商务经理',
  
          button: button1,
  
          color: false,
  
        }, {
  
          id: 3,
  
          name: '商务助理',
  
          button: button1,
  
          color: true,
  
        }, {
  
          id: 4,
  
          name: '运维员',
  
          button: button1,
  
          color: false,
  
        }, {
  
          id: 5,
  
          name: 'Java中级开发工程师',
  
          button: button1,
  
          color: true,
  
        }],
  
        searchContent: '',
  
        Jobbb: [],
  
  
  
      }
  
    },
  
    created() {
  
      this.fuzhi();
  
    },
  
    methods: {
  
      mouseOn: function(index) {
  
        this.Jobs[index].button = button2;
  
      },
  
      mouseOut: function(index) {
  
        this.Jobs[index].button = button1;
  
      },
  
      onclick(index) {
  
        this.Jobs[index].button = button3;

        this.$router.push({
  
            path: '/JobsDetails'
  
        })
  
      },
  
      fuzhi() {
  
        this.Jobbb = this.Jobs;
  
      },
  
      search() {
  
        this.Jobs = [];
  
        console.log(this.searchContent);
  
        for (let i = 0; i < this.Jobbb.length; i++) {
  
          for (let a = 0; a < this.Jobbb[i].name.length; a++) {
  
            for (let m = a; m < this.Jobbb[i].name.length; m++) {
  
              if (this.searchContent == this.Jobbb[i].name.slice(a, m + 1)) {
  
                console.log(this.Jobbb[i]);
  
                this.Jobs.push(this.Jobbb[i]);
  
              }
  
            }
  
          }
  
        }
  
      },
  
      JavaEngineer() {
  
        this.$router.push('/JavaEngineer')
  
      }

    }
  
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped media="all" type="text/css">

  @import url("../css/comm.css") screen;

.Joinbanner {
    position: relative;
    width: 100%;
    height: auto;
}

.MethodsBanner {
    width: 100%;
    position: relative;
}

.MethodsPic {
    width: 100%;
    height: auto;
}

.Job {
    position: relative;
    width: 100%;
    height: auto;
}

.InternPosition {
    width: 100%;
    height: auto;
    margin-top: 37px;
    position: relative;
}

.Jobtitle {
    width: 90px;
    height: 19px;
    font-family: FZZZHONGJW-GB1-0;
    font-size: 20px;
    line-height: 19px;
    letter-spacing: 1px;
    color: #000000;
    margin-left: 15px;
    margin-top: 37px
}

.searchContent2 ul {
    width: 856px;
    height: auto;
    position: relative;
    margin-bottom: 54px;
}

.searchContent2 ul li {
    width: 856px;
    position: relative;
}

.title8 {
    width: 100%;
    height: 100%;
}

.search {
    display: flex;
    justify-content: center;
}

.searchContent {
    display: flex;
    background: #f0f0f0;
    width: 856px;
    padding: 2rem 0;
    align-items: center;
}

.job-input {
    width: 200px;
    height: 40px;
    border: none;
    outline: none;
    margin-left: 20px;
}

.searchContent2 {
    position: relative;
    width: 856px;
    height: auto;
    box-sizing: border-box;
    margin: 0 auto;
}

.color {
    background-color: #f8f8f8
}

.Joblist li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
}

.searchImg {
    width: 127px;
    height: 40px;
}

.searchHot {
    width: 40px;
    height: 16px;
    margin: 0 20px;
}

.hotContent {
    width: 327px;
    height: 14px;
    font-family: FZLTHK-GBK1-0;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.7px;
    text-align: left;
    color: #333333;
}

.JobName {
    width: 200px;
    font-size: 16px;
    letter-spacing: 0.8px;
    text-align: left;
    color: #333333;
}

.LearnMoreButton {}

.JobsName {
    display: inline;
    border-bottom: 1px solid #999999;
    padding-bottom: 2px;
    font-size: 14px;
    cursor: pointer;
}

.onMouseActive {
    color: #42a4fc
}
</style>



// WEBPACK FOOTER //
// join.vue?05cd170f